<template>
  <b-navbar-nav>
    <b-nav-item>
      <router-link to="/product">محصولات</router-link>
    </b-nav-item>

     <b-nav-item>
      <router-link to="/address">آدرس</router-link>
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "menu-component",
  data() {
    return {};
  },

  computed: {
    ...mapGetters({}),
  },

  methods: {},
};
</script>

